document.addEventListener("DOMContentLoaded", function () { 

  const popup = document.getElementById("recent-purchase-popup");
  if (!popup) {
    console.log("Popup missing");
    return;
  }

  if (!Array.isArray(window.recentPurchaseProducts) || window.recentPurchaseProducts.length === 0) {
    console.log("No products found");
    return;
  }

  const products = window.recentPurchaseProducts;

  const userNames = [
    "Olivia","Amelia","Isla","Ava","Emily","Lily","Sophia","Grace","Poppy","Freya",
    "Evie","Millie","Florence","Rosie","Imogen",
    "Oliver","Harry","Jack","George","Noah","Leo","Charlie","Thomas","James",
    "William","Alfie","Henry","Theo","Freddie","Arthur"
  ];

  const timeOptions = [5, 10, 15, 20, 25, 30];

  function getRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function showPopup() {
    const product = getRandom(products);
    const userName = getRandom(userNames);
    const randomTime = getRandom(timeOptions);

    document.getElementById("popup-name").innerText = userName;
    document.getElementById("popup-product").innerText = product.title;
    document.getElementById("popup-image").src = product.image;
    document.getElementById("popup-time").innerText = randomTime + " minutes ago";

    popup.classList.remove("hidden");

    setTimeout(() => {
      popup.classList.add("hidden");
    }, 4000);
  }

  setTimeout(() => {
    showPopup();
    setInterval(showPopup, 8000);
  }, 1000);

});